import {
  Button,
  CircularProgress,
  FormControl,
  FormHelperText,
  FormLabel,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@material-ui/core";
import { IconFile, IconTrash } from "@tabler/icons-react";
import { useFormik } from "formik";
import * as yup from "yup";
import { isValidFileType } from "../../../helpers/fileHelper";
import { useState } from "react";
import { Alert } from "@material-ui/lab";
import { useUploadEcasFileMutation } from "../../../services/bl-import/BLImportService";

interface props {
  isLoading: boolean;
  onSend: (ecas: File) => void;
  onClose: () => void
}

const schema = yup.object().shape({
  file: yup.array().min(1, "Campo Requerido").required(),
});

const UploadEcas = ({ isLoading, onSend, onClose }: props) => {
  const [isErrorFile, setIsErrorFile] = useState(false);
  useUploadEcasFileMutation();
  const { errors, handleSubmit, setFieldValue, values } = useFormik({
    initialValues: {
      file: Array<File>(),
    },
    validationSchema: schema,
    onSubmit(values) {
      onSend(values.file[0]);
    },
  });

  const _handleSubmit = () => {
    handleSubmit();
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormLabel>Documento</FormLabel>
          {values.file.length > 0 ? (
            <TextField
              variant="outlined"
              fullWidth
              value={values.file[0].name}
              InputProps={{
                endAdornment: (
                  <IconButton
                    onClick={() => {
                      setIsErrorFile(false);
                      setFieldValue("file", []);
                    }}
                  >
                    <IconTrash />
                  </IconButton>
                ),
              }}
            />
          ) : (
            <FormControl error={Boolean(errors.file)} fullWidth>
              <input
                type="file"
                accept="application/pdf, message/rfc822"
                hidden
                id="file_ecas"
                onChange={(e) => {
                  setIsErrorFile(false);
                  const selectedFile = Array.from(
                    e.currentTarget.files || []
                  )[0];
                  if (selectedFile === null || selectedFile === undefined) {
                    return;
                  }

                  if (
                    !isValidFileType(
                      ["application/pdf", "message/rfc822"],
                      selectedFile
                    )
                  ) {
                    setIsErrorFile(true);
                  }

                  setFieldValue("file", [selectedFile]);
                }}
              />
              <label htmlFor="file_ecas">
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    border: "1px solid ",
                    borderColor:
                      Boolean(errors.file) === true ? "red" : "gainsboro",
                    borderRadius: 10,
                    flexDirection: "column",
                    justifyItems: "center",
                    alignItems: "center",
                    padding: "20px 0px",
                  }}
                >
                  <IconFile />
                  <br />
                  <Typography>Seleccione documento</Typography>
                </div>
              </label>
              {Boolean(errors.file) === true ? (
                <FormHelperText>{String(errors.file)}</FormHelperText>
              ) : null}
            </FormControl>
          )}
        </Grid>
        {isErrorFile === true ? (
          <Grid item xs={12}>
            <Alert severity="error">
              El tipo de archivo no es el correcto. Seleccione solo .pdf o .eml
            </Alert>
          </Grid>
        ) : null}
        <Grid item xs={6} md={6}>
          <Button variant="text" fullWidth size="large" onClick={onClose}>
            Cancelar
          </Button>
        </Grid>
        <Grid item xs={6} md={6}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            size="large"
            onClick={_handleSubmit}
            disabled={isLoading === true || isErrorFile}
            endIcon={isLoading === true ? <CircularProgress size={24} /> : null}
          >
            Subir Ecas
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default UploadEcas;
